import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError } from "../../utils/api.types";

import {
    IAddressResponse,
    IAddressFormInputs,
    IAddresses,
    IAddressUpdatePayload,
    IAddress
} from "../../utils/address.types";

/**
 * Fetch Addresses async thunk.
*/
export const fetchAddresses = createAsyncThunk(
    'address/fetchAddresses',
    async (accountId: string): Promise<IAddresses> => {
        const response = await axios.get(`/api/v1/address/${accountId}`);

        return response.data;
    }
);

export const selectedAddressID = createAction("address/selectedAddressID", (addressId) => {
    return {
        type: 'address/selectedAddressID',
        payload: addressId
    }
});

/**
 * Fetch Addresses async thunk.
*/
export const fetchAddressById = createAsyncThunk(
    'address/fetchAddressById',
    async (id: string): Promise<IAddress> => {
        const response = await axios.get(`/api/v1/address/address/${id}`);
        return response.data.address;
    }
);

/**
    * Add Address async Thunk.
*/
export const addAddress = createAsyncThunk(
    'address/addAddress',
    async (addressPayload: IAddressFormInputs): Promise<IAddressResponse> => {
        const response = await axios.post(`/api/v1/address`, addressPayload);

        return response.data
    }
);

/**
 * Update Address async Thunk.
 */
export const updateAddress = createAsyncThunk<
    IAddressResponse,
    IAddressUpdatePayload,
    {
        rejectValue: IError,
    }
>(
    'address/updateAddress',
    async ({ id, addressPayload }: IAddressUpdatePayload, thunkApi) => {
        try {
            const response = await axios.put(`/api/v1/address/${id}`, addressPayload);

            const { data } = response;

            if (response.status === 200) {
                return data;
            }

            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
    }
);

/**
 * Delete Address async Thunk.
 */
export const deleteAddress = createAsyncThunk(
    'address/deleteAddress',
    async (id: string): Promise<IDeleteApiResponse> => {
        const response = await axios.delete(`/api/v1/address/${id}`);

        response.data['id'] = id;

        return response.data
    }
);

